import { BRAND_HOSTS, REGUS } from 'src/app/shared/constants/brands.constants';

export const getLocationsSearchString = (): string => {
  if (window.location.search) {
    return window.location.search.substring(0, window.location.search.lastIndexOf('#'));
  }

  const hash = window.location.hash;
  const section = hash.slice(1).split('#')[0]; // remove fragment

  return section.split('?')[1] ?? '';
};

export const getLangFromLocale = (params): string => {
  const locale = params.locale;
  // 'en' as default fallback lang
  return locale ? (locale.split('-')[0] || 'en') : 'en';
};

export const formatLink = (link: string): string => {
  let culturePart: string | undefined = location.pathname.split('/').filter(part => (part.length && part !== 'booking'))[0];
  if (!culturePart) {
    const params = new URLSearchParams(window.location.hash);
    culturePart = params.get('locale');
  }
  return `${location.protocol}//${location.host}/${culturePart ? culturePart + '/' : ''}${link}`;
}

export const navigateToHome = (currentBrand: string): void => {
  const hostname = window.location.hostname.toLowerCase();
  const isLocalEnv = hostname === 'localhost' || hostname === 'localdev' || hostname.includes('127.0.0.1');

  let destinationUrl: string;

  if (isLocalEnv) {
    const brandHost = BRAND_HOSTS[currentBrand] || BRAND_HOSTS[REGUS];
    destinationUrl = `https://${brandHost}`;
  } else {
    destinationUrl = window.location.origin;
  }

  window.location.href = destinationUrl;
};
